import { Contact } from 'sr-types/lib/production/v1/graphql';
import { validateEmail, validatePhoneNumber } from '../common/form/Validator';
import { useI18n } from '../common/i18n/I18n';
import { failedToastMessage } from '../common/utils/commonUtils';
import { RESOURCE_TYPES_PEOPLE_PREVIEW } from '../resource/common/resourceConstants';

export const useImportPersonRowValidation = (fieldToValidate = 'contactInfo.email.address') => {
    const duplicatePersonToolTipMsg = useI18n('person.import.error.message');
    const invalidEmailMsg = useI18n('validation.email.invalid');
    const invalidPhoneMsg = useI18n('validation.phone.invalid');
    const invalidResourceTypeMsg = useI18n('validation.resourceType.invalid');
    const validation = (importedData, existingData, setInvalidData, setErrors) => {
        const validationRows = {};
        validateDuplicatePerson(importedData, existingData, fieldToValidate, validationRows, duplicatePersonToolTipMsg);
        validatePersonEmail(importedData, fieldToValidate, validationRows, invalidEmailMsg);
        validatePersonPhone(importedData, 'contactInfo.phone.number', validationRows, invalidPhoneMsg);
        validateResourceType(importedData, 'resourceType', validationRows, invalidResourceTypeMsg);
        if (Object.keys(validationRows).length) {
            setInvalidData(true);
            setErrors(validationRows);
        }
    };
    return validation;
};
function validateDuplicatePerson(
    importedData: any,
    guests: Contact[],
    fieldToValidate: string,
    validationRows: {},
    duplicatePersonToolTipMsg: string
) {
    if (guests.length > 0) {
        var failedValidation = false;
        importedData.forEach((row) => {
            guests.forEach((guest) => {
                if (guest.contactInfo?.email?.address && row[fieldToValidate] === guest.contactInfo.email.address) {
                    failedValidation = true;
                    if (!validationRows[row.id]) {
                        validationRows[row.id] = {};
                    }
                    if (!validationRows[row.id][fieldToValidate]) {
                        validationRows[row.id][fieldToValidate] = [];
                    }
                    if (validationRows[row.id][fieldToValidate].indexOf(duplicatePersonToolTipMsg) === -1) {
                        validationRows[row.id][fieldToValidate].push(duplicatePersonToolTipMsg);
                    }
                }
            });
        });
        if (failedValidation) {
            failedToastMessage('person.import.error.message');
        }
    }
}
function validatePersonEmail(importedData: any, fieldToValidate: string, validationRows: {}, invalidEmailMsg: string) {
    var invalidEmailAddress = false;
    importedData.forEach((row) => {
        if (!!row[fieldToValidate]) {
            const isValid = validateEmail(row[fieldToValidate]);
            if (!isValid) {
                invalidEmailAddress = true;
                if (!validationRows[row.id]) {
                    validationRows[row.id] = {};
                }
                if (!validationRows[row.id][fieldToValidate]) {
                    validationRows[row.id][fieldToValidate] = [];
                }
                validationRows[row.id][fieldToValidate].push(invalidEmailMsg);
            }
        }
    });
    if (invalidEmailAddress) {
        failedToastMessage('validation.email.invalid');
    }
}

function validatePersonPhone(
    importedData: any[],
    fieldToValidate: string,
    validationRows: Record<string, any>,
    invalidPhoneMsg: string
) {
    let invalidPhoneNumber = false;

    importedData.forEach((row) => {
        const phone = row[fieldToValidate] ?? row.phone;
        if (phone) {
            const isValid = validatePhoneNumber(phone);
            if (!isValid) {
                invalidPhoneNumber = true;

                if (!validationRows[row.id]) {
                    validationRows[row.id] = {};
                }

                if (!validationRows[row.id][fieldToValidate]) {
                    validationRows[row.id][fieldToValidate] = [];
                }

                validationRows[row.id][fieldToValidate].push(invalidPhoneMsg);
            }
        }
    });

    if (invalidPhoneNumber) {
        failedToastMessage('validation.phone.invalid');
    }
}

function validateResourceType(
    importedData: any[],
    fieldToValidate: string,
    validationRows: Record<string, any>,
    invalidResourceTypeMsg: string
) {
    let invalidResourceType = false;

    importedData.forEach((row) => {
        const value = row?.[fieldToValidate];
        if (!value) return;

        const normalizedValue = String(value).trim();
        const isAllowedResourceType = RESOURCE_TYPES_PEOPLE_PREVIEW.some(
            (resourceType) => resourceType.toLowerCase() === normalizedValue.toLowerCase()
        );
        if (isAllowedResourceType) {
            return;
        }

        invalidResourceType = true;
        if (!validationRows[row.id]) {
            validationRows[row.id] = {};
        }
        if (!validationRows[row.id][fieldToValidate]) {
            validationRows[row.id][fieldToValidate] = [];
        }
        validationRows[row.id][fieldToValidate].push(invalidResourceTypeMsg);
    });

    if (invalidResourceType) {
        failedToastMessage('validation.resourceType.invalid');
    }
}
